import { AdmsRepository } from 'src/repositories/users/adms.repository';
import { AdmsListTypeItem, CreateAndUpdateAdmType } from 'src/types/users';
import { api } from 'src/utils/axios';
import { create } from 'zustand';

type States = {
  isLoadingAdmsList: boolean;
  isLoadingDeleteAdm: boolean;
  isLoadingAdmToEdit: boolean;
  isLoadingCreateOrEdit: boolean;
  admsList: AdmsListTypeItem[];
  admToEdit: AdmsListTypeItem | null;
};

type Actions = {
  getAdmsList: () => Promise<void>;
  deleteAdms: (email: string[]) => Promise<void>;
  getAdmToEdit: (id: string) => Promise<void>;
  changeUserHome: (userId: string, home: string) => Promise<void>;
  createAdm: (adm: CreateAndUpdateAdmType) => Promise<void>;
  updateAdm: (adm: CreateAndUpdateAdmType) => Promise<void>;
  resetAdmToEdit: () => void;
};

type Adms = Actions & States;

const initialValues = {
  isLoadingAdmsList: false,
  isLoadingDeleteAdm: false,
  isLoadingAdmToEdit: false,
  isLoadingCreateOrEdit: false,
  admsList: [],
  admToEdit: null,
};

const admsRepository = new AdmsRepository(api);

export const useAdmsStore = create<Adms>((set: any, get: any) => ({
  ...initialValues,

  getAdmsList: async () => {
    set({ isLoadingAdmsList: true });

    const response = await admsRepository.getAdmsList();

    if (response.isLeft()) {
      set({ isLoadingAdmsList: false });
      throw new Error(response.value.message);
    }

    set({ admsList: response.value, isLoadingAdmsList: false });
  },

  deleteAdms: async (email: string[]) => {
    set({ isLoadingDeleteAdm: true });

    const response = await admsRepository.deleteAdms(email);

    if (response.isLeft()) {
      set({ isLoadingDeleteAdm: false });
      throw new Error(response.value.message);
    }
    await get().getAdmsList();
    set({ isLoadingDeleteAdm: false });
  },

  getAdmToEdit: async (id: string) => {
    set({ isLoadingAdmToEdit: true });

    const response = await admsRepository.getAdmToEdit(id);

    if (response.isLeft()) {
      set({ isLoadingAdmToEdit: false });
      throw new Error(response.value.message);
    }

    set({ admToEdit: response.value, isLoadingAdmToEdit: false });
  },

  changeUserHome: async (userId: string, home: string) => {
    set({ isLoadingCreateOrEdit: true });

    const response = await admsRepository.changeUserHome(userId, home);

    if (response.isLeft()) {
      set({ isLoadingCreateOrEdit: false });
      throw new Error(response.value.message);
    }
    set({ isLoadingCreateOrEdit: false });
  },

  createAdm: async (adm: CreateAndUpdateAdmType) => {
    set({ isLoadingCreateOrEdit: true });

    const response = await admsRepository.createAdm(adm);

    if (response.isLeft()) {
      set({ isLoadingCreateOrEdit: false });
      throw new Error(response.value.message);
    }

    set({ isLoadingCreateOrEdit: false });
  },

  updateAdm: async (adm: CreateAndUpdateAdmType) => {
    set({ isLoadingCreateOrEdit: true });

    const response = await admsRepository.updateAdm(adm);

    if (response.isLeft()) {
      set({ isLoadingCreateOrEdit: false });
      throw new Error(response.value.message);
    }

    set({ isLoadingCreateOrEdit: false });
  },

  resetAdmToEdit: () => {
    set({ admToEdit: null });
  },
}));
